export const parseText = (text) => {
    const parts = text.split(/(\*\*.*?\*\*|\[.*?\]\(.*?\)|\{.*?\})/g);
    const result = [];

    parts.forEach((part, index) => {
      if (!part) return;

      // Bold
      if (part.startsWith("**") && part.endsWith("**")) {
        result.push(<strong key={index}>{part.slice(2, -2)}</strong>);
        return;
      }

      // Link [text](url)
      if (part.startsWith("[") && part.includes("](")) {
        const match = part.match(/\[(.*?)\]\((.*?)\)/);
        if (match) {
          const [, linkText, url] = match;
            result.push(
              <a
                key={index}
                href={url}
                rel="noopener noreferrer"
                className="content-link"
              >
                {linkText}
              </a>
            );
            return;
        }
      }

      // Colored text {color:}
      if (part.startsWith("{") && part.endsWith("}")) {
        const colorMatch = part.match(/\{color:(.*?);(.*?)\}/);
        if (colorMatch) {
          const [, color, innerText] = colorMatch;
          result.push(
            <span key={index} style={{ color }}>
              {innerText}
            </span>
          );
          return;
        }
      }

      // Handle newlines
      const lines = part.split(/\n/);
      lines.forEach((line, li) => {
        if (line) {
          result.push(<span key={`${index}-line-${li}`}>{line}</span>);
        }
        if (li < lines.length - 1) {
          result.push(<br key={`${index}-br-${li}`} />);
        }
      });
    });

    return result;
  };